import React from 'react';
import ReactDOM from 'react-dom';

// components
import App from './App';

// styles
import './index.css';

ReactDOM.render(
	<React.StrictMode>
		<App />
	</React.StrictMode>,
	document.getElementById('root')
);
